exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form-item__content{margin-left:0!important}.has-error .el-input__inner,.has-error .el-select .el-input__inner,.has-error .el-textarea__inner{border-color:#f56c6c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18ac9316","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/dispatches/Carrier/partials/DialogReferenceDocument.vue
// module id = oxxD
// module chunks = 0